import type { BundleOfferDto } from '../bundles/bundleOffers.schema';
import type { QueryOptionsOverride } from '../queryOptions.helpers';
import { QueriesKeys } from '../queriesKeys';
import { fastShopApi } from './fast-shop.api';

export const fastShopQueries = {
  meFastOffers: (options?: QueryOptionsOverride<BundleOfferDto[]>) => ({
    queryKey: [QueriesKeys.meFastOffers],
    queryFn: () => fastShopApi.getMeFastBundleOffers(),
    ...options,
  }),
};
